import { init as initFS } from '@fullstory/browser'
import '@stone-payments/jade-design-tokens/pagarme/fonts.css'
import '@stone-payments/jade-design-tokens/pagarme/theme.css'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import getGoogleAnalyticsIds from './utils/googleAnalytics'
import { applyStoneRebrandFavicon } from './utils/stone-rebrand-favicon.utils'
import { toStoneBrand } from './utils/stone-rebrand.utils'

import 'emerald-workbench/dist/emerald.pagarme.min.css'

Vue.config.productionTip = false

// Stone rebrand (app interna, incondicional)
applyStoneRebrandFavicon()
document.title = toStoneBrand(document.title)

if (['production'].includes(process.env.VUE_APP_CORE_ENV)) {
  initFS({ orgId: 'BKP05' })

  const ids = getGoogleAnalyticsIds()
  ids.length &&
    Vue.use(VueAnalytics, {
      id: ids,
      router,
      debug: {
        enabled: false, // Turn on for activate debuging
        sendHitTask: process.env.VUE_APP_CORE_ENV
      }
    })
}

const recaptchaV3Flag = Number(process.env.VUE_APP_RECAPTCHA_VERSION)
const isRecaptchaV3 = recaptchaV3Flag === 3

if (isRecaptchaV3) {
  Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_KEY_V_THREE,
    loaderOptions: {
      explicitRenderParameters: {
        badge: 'bottomleft'
      }
    }
  })
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
